import { State } from "country-state-city";

// export const server = "http://localhost:4050/api/v1";
export const server = "https://dotnetserver.tanushreesaha.com/api/v1";

export const STATES_LIST = State.getStatesOfCountry("IN");

export const defaultUserImage = "";
